import React, { useCallback, useMemo } from "react";
import StatisticsChart from "components/Cards/StatisticsChart";

const getCountPercentage = (count: number, total: number) => {
  return ((count / total) * 100).toFixed(2);
};

export const PieChart = React.memo(({
  series,
  title,
  labels,
  colors,
  isLoading = false
}: {
  series: number[];
  title: string;
  colors: string[];
  labels: string[];
  isLoading?: boolean;
}) => {
  const handleTooltip = useCallback(({ series, seriesIndex, w }: { series: number[]; seriesIndex: number; w: any }) => {
    return (
      `<div class="arrow_box p-2 bg-[${w.globals.colors[seriesIndex]}]">` +
      "<span>" +
      w.globals.labels[seriesIndex] +
      ": " +
      series[seriesIndex] +
      " - " +
      getCountPercentage(
        series[seriesIndex],
        series.reduce((acc, curr) => acc + curr, 0)
      ) +
      "%" +
      "</span>" +
      "</div>"
    );
  }, []);

  const chartConfig = useMemo(() => ({
    type: "donut" as const,
    height: 220,
    series,
    options: {
      colors,
      labels,
      chart: {
        type: "donut" as const
      },
      tooltip: {
        theme: "dark",
        custom: handleTooltip
      } as any,
      dataLabels: {
        enabled: false
      }
    }
  }), [series, colors, labels, handleTooltip]);

  return (
    <StatisticsChart
      color="white"
      title={title}
      isLoading={isLoading}
      chart={chartConfig}
    />
  );
});
